<template>
    <div v-show="value" class="backdrop" @click="dismiss">
        <div class="dialog" @click.stop>
            <div class="body" autofocus>
                <div class="d-flex mb-4">
                    <h2 v-if="title" class="flex-grow-1">{{ title }}</h2>
                    <a @click="dismiss()">
                        <v-icon size="36">close</v-icon>
                    </a>
                </div>
                <slot />
            </div>
            <div v-if="$scopedSlots.footer" class="footer">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'TabDialog',
    props: {
      title: String,
      value: Boolean
    },
    methods: {
      dismiss () {
        this.$emit('input', false)
      },
      TravarScroll (travar) {
        document.querySelector('html').style.overflowY = travar ? 'hidden' : 'auto'
      }
    }
  }
</script>

<style lang="scss" scoped>
    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 20;
        display: flex;
    }
    .dialog {
        height: 100%;
        background: #FFF;
        position: fixed;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
    }
    .body {
        width: 100%;
        flex: 1;
        overflow: auto;
        padding: 24px 16px;
    }
    .footer {
        padding: 24px 16px;
        border-top: 1px solid var(--gray);
    }
    h2 {
        color: var(--primary);
        text-transform: uppercase;
    }
</style>
